export default [
  {
    path: '/invoice-classes',
    name: 'invoice-classes',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice-class/index.vue')
  },
  {
    path: '/invoice-classes/create',
    name: 'invoice-classes-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice-class/create.vue')
  }
]
